import { Link } from "react-router-dom";

export function Logo({ dark = false, className = "" }) {
  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="SefKam"
        className="h-8 w-8 rounded-lg object-cover"
      />
      <span className={`font-display text-lg font-semibold tracking-tight ${dark ? "text-white" : "text-[#07111F]"}`}>
        SefKam
      </span>
    </Link>
  );
}
